<template>
	<div class="plug-tree">
		<div style="overflow: auto;height:calc(100% - 40px)">
			<el-tree :props="props" ref="nodeTree" :highlight-current="true" :current-node-key="nodeId"  node-key="id" @node-click="nodeClick" :load="loadNode" lazy> </el-tree>
		</div>
	</div>
</template>

<script>
	import publicAPI from '../../api-path/public-api'
	export default {
		name: "tree",
		props: {
			areaId:{
				type:String,
			}
		},
		data() {
			return {
				newSwitchVal: false,
				areaTreeList:[],
				nodeId: '0',
				props: {
					label: 'name',
					key: 'id',
					children: 'areaTreeListResList',
					isLeaf: 'isLast'
				},
			}
		},
		created() {
			if(!this.areaId){
				this.areaId=localStorage.getItem('centerId')?localStorage.getItem('centerId'):'0'
			}
			if (this.switchVal) {
				this.newSwitchVal = this.switchVal === this.newSwitchVal ? this.newSwitchVal : this.switchVal
			}
		},

		methods: {
			loadNode(node, resolve) {
				let $this=this;
				if (node.level === 0) {
					// let areaId= localStorage.getItem('centerId')?localStorage.getItem('centerId'):'0';
					let areaId= this.areaId;
					$this.$http.get(publicAPI.areaListTree,{params: { id: areaId }}).then(res => {
						if (res.status==200) {
							$this.areaTreeList=res.result.areaTreeListResList;
							// if(this.isfirstChoice){
							// 	setTimeout(function () {
							// 		$this.$nextTick(function () {
							// 			this.nodeId=res.result.id;
							// 			$this.$refs.nodeTree.setCurrentKey(this.nodeId)
							// 			$this.$emit('nodeClick', res.result)
							// 		})
							// 	},1000)
							// }
							return resolve([res.result]);
						}
					})


				}
				if (node.level ==1) {
					return resolve(this.areaTreeList);
				}
				if (node.level > 1) {
					this.loadchildnode(node, resolve);
				}
			},
			loadchildnode(node, resolve) {
				this.$http.get(publicAPI.areaListTree, {
					params: { id: node.data.id }
				}).then(res => {
					if (res.status==200) {
						return resolve(res.result.areaTreeListResList);
					}
				})
			},
			nodeClick(node) {
				this.$emit('nodeClick', node);
			}
		}
	}
</script>

<style lang="less" scoped>
	.plug-tree {
		width: 260px;
		height: 100%;
		.topCut {
			display: flex;
			padding: 5px;
			flex-direction: row;
			justify-content: space-between;
			height: 30px;
			background: #e3f7fc;
			color: #666;
			line-height: 30px;
			text-align: center;
			font-size: 14px;
			.title{
				width: 100%;
				text-align: center;
				display: inline-block;
			}
		}
	}
</style>
